export const VALUE_SHOULD_NOT_BE_BLANK = 'c1051bb4-d103-4f74-8988-acbcafc7fdc3'
export const VALUE_IS_INVALID = 'de1e3db3-5ed4-4941-aae4-59f3667cc3a3'
export const EMAIL_INVALID_FORMAT_ERROR = 'bd79c0ab-ddba-46cc-a703-a7a4b08de310'
export const EMAIL_MX_CHECK_FAILED_ERROR = 'bf447c1c-0266-4e10-9c6c-573df282e413'
export const EMAIL_HOST_CHECK_FAILED_ERROR = '7da53a8b-56f3-4288-bb3e-ee9ede4ef9a1'
export const PASSWORDS_DO_NOT_MATCH = '7c2c81bb-7e18-4418-8234-0f2909647dae'



// WEBPACK FOOTER //
// ./src/user-api/user-api-client-constants.js